export function SettingsPage() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Settings</h1>
      </div>
      <div className="card">
        <p>
          <strong>Carvoeiro Nav</strong> v1.0 — Barrier Island Digital.
        </p>
        <p className="muted" style={{ marginTop: 8 }}>
          PWA cache key <code>carvoeiro-nav-shell-v22</code>. Bump <code>VERSION</code> in{' '}
          <code>public/sw.js</code> when the app shell changes.
        </p>
        <p className="muted" style={{ marginTop: 8 }}>
          Favorites live in this browser only. No account, no PIN.
        </p>
      </div>
    </div>
  );
}
